import { useTranslations } from '~i18n/hooks';
import { ButtonStroked } from '~shared/ui/atoms/Buttons/ButtonStroked';

import type {
	BotWizardField,
	BotWizardFieldNames,
	BotWizardValues,
} from '../../model/types';
import { Field } from '../Field';
import { WorkingArea } from '../styles';
import { StyledTextareaField } from './styles';

type Props = {
	fields: Record<BotWizardFieldNames, BotWizardField>;
	values: BotWizardValues;
	customValues: { [key in BotWizardFieldNames]?: string };
	personality: string;
	setPersonality: (value: string) => void;
	look: string;
	nameError?: string;
	isGeneratedPromptLoading: boolean;
	setLook: (value: string) => void;
	onSurpriseMe: () => void;
	personalityError: string;
};

export const PromptStep = ({
	fields,
	values,
	customValues,
	personality,
	nameError,
	setPersonality,
	look,
	setLook,
	isGeneratedPromptLoading,
	personalityError,
	onSurpriseMe,
}: Props) => {
	const t = useTranslations('BotWizard');
	return (
		<>
			<Field
				nameError={nameError}
				id="name"
				field={fields.name}
				values={values}
				customValues={customValues}
				disabled={isGeneratedPromptLoading}
			/>
			<WorkingArea>
				<StyledTextareaField
					error={personalityError}
					disabled={isGeneratedPromptLoading}
					value={personality}
					onChange={(e) => setPersonality(e.target.value)}
					label={t('promptStepPersonalityTitle')}
					placeholder={t('promptStepPersonalityTooltip')}
					tooltip={t('promptStepPersonalityTooltip')}
					maxLength={1000}
				/>
			</WorkingArea>
			<WorkingArea>
				<StyledTextareaField
					disabled={isGeneratedPromptLoading}
					value={look}
					onChange={(e) => setLook(e.target.value)}
					label={t('promptStepLookTitle')}
					placeholder={t('promptStepLookTooltip')}
					tooltip={t('promptStepLookTooltip')}
					maxLength={1000}
				/>
			</WorkingArea>
			<ButtonStroked
				loading={isGeneratedPromptLoading}
				onClick={onSurpriseMe}
				borderRadius="XS"
				size="M"
			>
				{t('promptStepSurpriseMeButtonText')}
			</ButtonStroked>
		</>
	);
};
